export default __webpack_public_path__ + "static/media/OpenLaw.2ae4df99.png";